<div class="flex flex-col h-full" [waiting]="loadingService.isLoading$(this) | async">
  @if (dataSource) {
    <icz-documents-table
      tableTitle="Obsah spisu" [disableUrlParameters]="true"
      tableId="file-detail-content" class="grow" [viewType]="DocumentView.FILE_CONTENTS"
      [dataSource]="$any(dataSource)" [hideTableToolbarButtons]="!documentsListingPermissionGranted"
    >

      <div noDataLabel class="col-16">
        <icz-label label="Žádné založené dokumenty ve spisu" class="my-32"></icz-label>
        <icz-button primary label="Založit vlastní dokument do spisu" (onAction)="goToCreateDocument(true)"></icz-button>
        <icz-button primary label="Založit doručený dokument do spisu" (onAction)="goToCreateDocument(false)"></icz-button>
      </div>

    </icz-documents-table>
  }
</div>
